export enum SequenceStepConfig {
  MaxVariants = 26,
  MinActiveVariants = 1,
}

export enum SequenceStepExecutionDay {
  MinDay = 1,
  MaxDay = 365,
}

export enum SequenceStepType {
  AutomatedEmail = 1,
  ManualEmail = 2,
  Call = 3,
  Sms = 4,
  LinkedIn = 5,
  Twitter = 6,
}
